export enum FlowOutputDataStrategy {
    AddedData = "all_data_except_inputs",
    AllData = "all_data",
    ChangedData = "changed_data",
    SpecifiedData = "specified_data",
}
